/**
 * groupCoursesApi.js
 * 
 * Servicio para consumir API de cursos grupales (estudiantes)
 * Endpoints: /api/group-courses/*
 */

import apiClient from './apiClient';

/**
 * Obtener catálogo de cursos grupales publicados
 * 
 * @param {Object} filters - Filtros opcionales
 * @param {string} filters.category - Categoría del curso
 * @param {string} filters.difficulty - Nivel de dificultad
 * @param {string} filters.search - Búsqueda por título/descripción
 * @returns {Promise<Array>} Lista de cursos publicados
 */
export const getCatalog = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.category) params.append('category', filters.category);
  if (filters.difficulty) params.append('difficulty', filters.difficulty);
  if (filters.search) params.append('search', filters.search);
  
  const queryString = params.toString();
  const url = queryString 
    ? `/group-courses/catalog?${queryString}`
    : '/group-courses/catalog';
  
  const response = await apiClient.get(url);
  return response.data;
};

/**
 * Obtener detalle completo de un curso grupal
 * 
 * @param {string} courseId - ID único del curso
 * @returns {Promise<Object>} Detalle completo del curso con semanas
 */
export const getCourseDetail = async (courseId) => {
  const response = await apiClient.get(`/group-courses/${courseId}`);
  return response.data;
};

/**
 * Inscribirse a un curso grupal
 * 
 * @param {string} courseId - ID único del curso
 * @returns {Promise<Object>} Resultado de la inscripción con datos del grupo asignado
 */
export const enrollInCourse = async (courseId) => {
  const response = await apiClient.post(`/group-courses/${courseId}/enroll`);
  return response.data;
};

export default {
  getCatalog,
  getCourseDetail,
  enrollInCourse
};
